export default __webpack_public_path__ + "static/media/kenton.223bf6dc.png";